import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Loading = () => {
  const [greeting, setGreeting] = useState(null);

  useEffect(() => {
    const greetings = [
      "",
      "hi",
      "こんにちは",
      "hola",
      "привет",
      "bonjour",
      "hello",
    ];

    greetings.forEach((el, index) => {
      setTimeout(() => setGreeting(el), index * 275);
    });
  }, []);

  return (
    <motion.div className="loading">
      <div className="loading-animation">
        <motion.p
          initial={{ opacity: 0, z: 100 }}
          animate={{ opacity: 1, z: 0 }}
          exit={{ opacity: 0, z: -100 }}
          transition={{ duration: 1, delay: 0.25 }}
        >
          {greeting}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default Loading;
